<template>
  <div>

    <div v-if="categories.length < 1">Fetching category product counts. Pleases wait...</div>

    <div style="display:flex; flex-wrap: wrap; gap:60px;">
        <div style="padding:0 0 20px;" v-for="(category, category_index) in categories" :key="category_index">
          <div style="font-size:15px; padding-bottom:8px; ">{{ category.name }} <small>({{ category.product_count }})</small></div>
          <div style="padding:8px 0 0 4px; font-style:italic; font-size:13px;" v-for="(subcategory, subcategory_index) in category.subcategories" :key="subcategory_index">
              {{ subcategory.name }} <small>({{ subcategory.product_count }})</small>
          </div>
      </div>
    </div>


    <div style="margin-top:20px; display:flex; align-items:center;  gap:20px; ">

      <div>From:</div>

      <select v-model="from_category" >
        <option v-for="(category, category_index) in categories_flat_array" :key="category_index" :value="category">{{ category.title }}</option>
      </select>

      <div>To: </div>

      <select v-model="to_category" >
        <option v-for="(category, category_index) in categories_flat_array" :key="category_index" :value="category">{{ category.title }}</option>
      </select>

      <a class="admin__button" style="margin:0;" @click="moveProductsToSubcategory__clicked">Move Products To Subcategory</a>
    </div>
  </div>
</template>

<script>
  import Category from "../../../models/Category";
  import ShopifyProduct from "../../../models/ShopifyProduct";

  export default {
    data(){
      return{
        categories: [],
        categories_flat_array: Category.toFlatArray(),
        from_category: null,
        to_category: null,
        shopify_sites: [],
      }
    },
    async mounted(){

      let categories = Category.categories;

      for(let category of categories){
        category.product_count = await ShopifyProduct.count("category", "==", category.name);

        for(let subcategory of category.subcategories){
          subcategory.product_count = await ShopifyProduct.count("subcategory", "==", subcategory.name);
        }

      }

      this.categories = categories;

      this.from_category = this.categories_flat_array[0];
      this.to_category = this.categories_flat_array[0];



    },
    methods: {
      async moveProductsToSubcategory__clicked(event) {
        await this.moveToSubcategory();
       // await this.moveToCategory();
      },
      async moveToSubcategory(){
        let products = await ShopifyProduct.where("subcategory", "==", this.from_category.subcategory);

        for(let product of products){
          product.category = this.to_category.category;
          product.subcategory = this.to_category.subcategory;
          await product.save();
        }

        alert(`${products.length} Items moved from ${this.from_category.subcategory} to ${this.to_category.subcategory}`);
      },

      async moveToCategory(){
        let products = await ShopifyProduct.where("category", "==", this.from_category.category);

        for(let product of products){
          product.category = this.to_category.category;
          await product.save();
        }

        alert(`${products.length} Items moved from ${this.from_category.category} to ${this.to_category.category}`);

      },
    }
  }
</script>
